import { useQuery } from "@tanstack/react-query";

import { GraphQLAPI, GraphQLResult, queries } from "@examspark/api";
import { Workspace } from "@examspark/types";

export const useQueryGetWorkspace = (workspaceId?: string) => {
  return useQuery({
    enabled: !!workspaceId,
    queryKey: ["workspace", workspaceId],
    queryFn: async () => {
      const result = (await GraphQLAPI.query({
        query: queries.workspace.getWorkspace({
          label: "GetWorkspace",
          fields: `
            id
            sk
            name
            type
            createdAt
            updatedAt
            isDisabled
            tags {
              key
              type
              value
            }
        `,
        }),
        variables: {
          input: {
            id: workspaceId,
            sk: `workspace`,
          },
        },
      })) as GraphQLResult<{
        getWorkspace: Workspace;
      }>;

      return result.data?.getWorkspace;
    },
  });
};
